<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">destination charge 詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save">{{
          $t('app.buttons.save')
        }}</v-btn>
        <!-- <v-btn @click="remove" v-if="$route.path.indexOf('new')===-1">{{$t('app.buttons.remove')}}</v-btn> -->
        <v-btn @click="remove" v-if="false">{{
          $t('app.buttons.remove')
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <remote-autocomplete
                :rules="[(v) => v != null || `必須項目`]"
                label="サプライヤー"
                url="companies/kv?code=Jusda"
                v-model="form.supplierId"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <remote-select
                :filter="(p) => p.isDestinationCharge"
                :init="(p) => p.isDestinationCharge"
                :rules="[(v) => v != null || `必須項目`]"
                item-text="name"
                item-value="id"
                label="費用項目"
                returnObject
                url="charge-items/kv?projection=full"
                v-model="chargeItem"
              />
            </v-flex>

            <v-flex xs4>
              <remote-select
                :rules="[(v) => v != null || `必須項目`]"
                label="商品種類"
                url="commodity-types/kv"
                v-model="form.commodityTypeId"
              />
            </v-flex>
            <v-flex xs4>
              <remote-select
                :rules="[(v) => v != null || `必須項目`]"
                label="Special"
                url="specials/kv?code=WAREHOUSE_TRANSPORT"
                v-model="form.specialId"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                :rules="[(v) => v != null || `必須項目`]"
                url="ports/kv"
                v-model="form.departurePortCode"
              />
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                :rules="[(v) => v != null || `必須項目`]"
                url="ports/kv"
                v-model="form.destinationPortCode"
              />
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                :rules="[(v) => v != null || `必須項目`]"
                label="着地"
                url="warehouses/fee-kv"
                v-model="form.destinationWarehouseId"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                :items="chargeItem.recordUnits"
                :rules="[(v) => v != null || `必須項目`]"
                item-text="ja_JP"
                item-value="id"
                label="課金単位"
                v-model="form.chargeUnitId"
              />
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                :label="$t('app.labels.currency')"
                :rules="[(v) => v != null || `必須項目`]"
                url="currencies/kv"
                v-model="form.currencyCode"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            v-if="form.chargeUnitId && form.chargeUnitId.indexOf('-CTN') !== -1"
          >
            <v-flex xs6>
              <remote-select
                :label="$t('app.labels.stackType')"
                :rules="[(v) => v != null || `必須項目`]"
                url="stack-types/kv?code=FCL"
                v-model="form.stackTypeId"
              />
            </v-flex>
            <v-flex xs6>
              <remote-select
                :rules="[(v) => v != null || `必須項目`]"
                label="コンテナタイプ"
                url="container-types/kv"
                v-model="form.containerTypeId"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            v-if="form.chargeUnitId && form.chargeUnitId.indexOf('-KG') !== -1"
          >
            <v-flex xs4>
              <v-text-field
                label="ミニマム"
                type="number"
                v-model="form.minPrice"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="From"
                type="number"
                v-model="form.rangeFrom"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field label="To" type="number" v-model="form.rangeTo" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                :rules="[
                  (v) =>
                    (v !== null && v !== '' && v !== undefined) || `必須項目`,
                  (v) => v >= 0 || `負の金額`,
                ]"
                label="請求単価"
                type="number"
                v-model="form.requestPrice"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :rules="[
                  (v) =>
                    (v !== null && v !== '' && v !== undefined) || `必須項目`,
                  (v) => v >= 0 || `負の金額`,
                ]"
                label="支払単価"
                type="number"
                v-model="form.paymentPrice"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <date-picker
                :max="form.endDate"
                :rules="[(v) => v != null || `必須項目`]"
                label="適用開始日"
                v-model="form.startDate"
              />
            </v-flex>
            <v-flex xs6>
              <date-picker
                :min="form.startDate"
                :rules="[(v) => v != null || `必須項目`]"
                label="適用終了日"
                v-model="form.endDate"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field label="備考" v-model="form.comments" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import New from '../New'
export default {
  mixins: [New],
  data() {
    return {
      form: {
        departureType: 'PORT',
        destinationType: 'PORT',
        chargeUnitId: null,
      },
    }
  },
  watch: {
    'form.chargeUnitId'(val) {
      if (!val) return
      if (val.indexOf('-KG') !== -1) {
        this.form.stackTypeId = null
        this.form.containerTypeId = null
      }
      if (val.indexOf('-CTN') !== -1) {
        this.form.minPrice = null
        this.form.rangeFrom = null
        this.form.rangeTo = null
      }
    },
  },
}
</script>
